import { useLocation } from 'wouter';
import { LayoutDashboard, Users, Map, Bell, MapPin } from 'lucide-react';

interface NavItem {
  path: string;
  icon: typeof LayoutDashboard;
  label: string;
}

const navItems: NavItem[] = [
  { path: '/supervisor', icon: LayoutDashboard, label: 'Painel' },
  { path: '/supervisor/team', icon: Users, label: 'Equipe' },
  { path: '/supervisor/map', icon: Map, label: 'Mapa' },
  { path: '/supervisor/alerts', icon: Bell, label: 'Alertas' },
  { path: '/supervisor/tracking', icon: MapPin, label: 'Rastro' },
];

export default function SupervisorNav({ alertCount = 0 }: { alertCount?: number }) {
  const [location, setLocation] = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 pb-safe z-50">
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => {
          const isActive = location === item.path || (item.path !== '/supervisor' && location.startsWith(item.path));
          const Icon = item.icon;
          return (
            <button
              key={item.path}
              onClick={() => setLocation(item.path)}
              className={`flex flex-col items-center justify-center gap-0.5 w-full h-full relative
                ${isActive ? 'text-primary' : 'text-gray-400'}`}
            >
              <div className="relative">
                <Icon size={22} strokeWidth={isActive ? 2.5 : 1.5} />
                {item.path === '/supervisor/alerts' && alertCount > 0 && (
                  <span className="absolute -top-1.5 -right-2.5 bg-red-500 text-white text-[10px] font-bold rounded-full min-w-[16px] h-4 flex items-center justify-center px-1">
                    {alertCount > 9 ? '9+' : alertCount}
                  </span>
                )}
              </div>
              <span className="text-[10px] font-medium">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
